import { format } from 'date-fns';
import setUiMessage from '../Utilities/Tostify';
import { post } from '../components/Auths/AuthToken';

export const getAppData = async (prams) => {
  const response = await post('api/auth/getapplist', prams);
  if (response.status === 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch data');
  }
};

export const handleAppStatus = async (
  appointmentId,
  currentStatusId,
  currentStatusAutoIncId,
  patient_id,
  loginUserId,
  recurringVal = 0,
  reason = ''
) => {
  try {
    const response = await post(
      'api/appointment/Appointment/changeCurrentStatus',
      {
        appointmentId: appointmentId,
        currentStatusId: currentStatusId,
        currentStatusAutoIncId: currentStatusAutoIncId,
        patient_id: patient_id,
        loginUserId: loginUserId,
        recurringVal: recurringVal,
        reason: reason,
      }
    );
    return response;
  } catch (err) {
    setUiMessage('err', err.message);
  }
};

export const handleCounsellingFormMidItem = async (childId = '', type = '') => {
  try {
    const response = await post('api/patient/progressNote/deleteCounChield', {
      childId,
      type,
    });
    return response;
  } catch (err) {
    setUiMessage('err', err.message);
  }
};

export const handleSuggestTimePop = async (
  resource = 0,
  appDate = new Date(),
  location = 0
) => {
  try {
    const response = await post('api/appointment/appointment/suggestTimePop', {
      selectdResource: resource,
      selectdDate: format(appDate, 'yyyy-MM-dd'),
      selectedLocation: location,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to fetch data');
    }
  } catch (err) {
    throw new Error('Failed to fetch data');
  }
};
